import { get, ref, set } from "firebase/database";
import React, { useEffect, useState } from "react";
import { auth, db, storage } from "../../utilities/firebaseConfig";
import { Link, useNavigate } from "react-router-dom";
import {
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";

function InfopageTwo() {
  const [expyears, setExpyears] = useState("");
  const [certificateName, setCertificateName] = useState("");
  const [issuingOrganisation, setIssuingOrganisation] = useState("");
  const [monthyear, setMonthyear] = useState("");
  const [fromtime, setFromTime] = useState("");
  const [totime, setToTime] = useState("");
  const [govissuedid, setGovIssuedId] = useState("");
  const [proofAddressFile, setProofAddressFile] = useState(null);
  const [govIssuedIdFile, setGovIssuedIdFile] = useState(null);
  const [certificateFile, setCertificateFile] = useState(null);
  const [profileFile, setProfileFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState(null);

  const [service, setService] = useState("");
  const [categories, setCategories] = useState({});
  // const [selectedCategory, setSelectedCategory] = useState(
  //   "Appliance Installation and Repairs"
  // );
  const [services, setServices] = useState([]);
  const [checkam, setCheckam] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedServices, setSelectedServices] = useState([]);
  const [selecttday, setSelecttday] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      setLoading(true);
      const user = auth.currentUser;
      if (!user) {
        console.error("No authenticated user found.");
        setLoading(false);
        navigate("/signup");
        return;
      }

      try {
        const userRef = ref(db, `technicians/${user.uid}`);
        const snapshot = await get(userRef);
        if (snapshot.exists()) {
          setUserData(snapshot.val());
        } else {
          console.error("User data not found.");
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
      setLoading(false);
    };

    fetchUserData();
  }, []);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const snapshot = await get(ref(db, "categories"));
        if (snapshot.exists()) {
          const data = snapshot.val();
          let servicesList = [];
          Object.values(data).forEach((category) => {
            if (category.services) {
              Object.values(category.services).forEach((service) => {
                servicesList.push(service.name);
              });
            }
          });
          setServices(servicesList);
        }
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };
    fetchServices();
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const snapshot = await get(ref(db, "categories"));
        if (snapshot.exists()) {
          setCategories(snapshot.val());
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);

  const handleFileChange = (event, setFile) => {
    setFile(event.target.files[0]);
  };

  const saveDetails = async () => {
    setLoading(true);
    const userId = auth.currentUser.uid;

    try {
      let proofAddressUrl = "";
      let govIssuedIdUrl = "";
      let certificateUrl = "";
      let profileUrl = "";

      if (proofAddressFile) {
        const proofAddressRef = storageRef(
          storage,
          `technicians/${userId}/proof_address`
        );
        await uploadBytes(proofAddressRef, proofAddressFile);
        proofAddressUrl = await getDownloadURL(proofAddressRef);
      }

      if (govIssuedIdFile) {
        const govIssuedIdRef = storageRef(
          storage,
          `technicians/${userId}/gov_issued_id`
        );
        await uploadBytes(govIssuedIdRef, govIssuedIdFile);
        govIssuedIdUrl = await getDownloadURL(govIssuedIdRef);
      }

      if (certificateFile) {
        const certificateRef = storageRef(
          storage,
          `technicians/${userId}/certificate`
        );
        await uploadBytes(certificateRef, certificateFile);
        certificateUrl = await getDownloadURL(certificateRef);
      }

      if (profileFile) {
        const profileRef = storageRef(
          storage,
          `technicians/${userId}/profile_image`
        );
        await uploadBytes(profileRef, profileFile);
        profileUrl = await getDownloadURL(profileRef);
      }

      // Ensure selectedServices is stored with a default price (0)

      await set(ref(db, `technicians/${userId}`), {
        ...userData,
        services: selectedServices, // Store selected services
        expyears,
        certificateName,
        issuingOrganisation,
        monthyear,
        certificateUrl,
        govissuedid,
        govIssuedIdUrl,
        proofAddressUrl,
        profileUrl,
        workingHour: selecttday,
        level: "elite",
        rating: 4.5,
        step1Completed: true,
        step2Completed: true,
        step4Completed: true,
      });

      navigate("/technician/dashboard");
    } catch (error) {
      console.error("Error saving details:", error);
      alert("Failed to save details. Please try again.");
    }
    setLoading(false);
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  const handleCategoryChange = (categoryName) => {
    setSelectedCategory(categoryName);
    setSelectedServices([]); // Reset selected services when changing category
  };

  // Handle selecting and removing services
  const handleServiceToggle = (serviceName) => {
    setSelectedServices((prevServices) => {
      const existingService = prevServices.find((s) => s.name === serviceName);

      if (existingService) {
        // Remove service if already selected
        return prevServices.filter((s) => s.name !== serviceName);
      } else {
        // Add service with a default price of 0
        return [...prevServices, { name: serviceName, price: 0 }];
      }
    });
  };

  return (
    <>
      <div className={`navbar visible`}>
        <div className='navbar-container'>
          <div className='navbar-logo-left'>
            <Link to='/dashboard' className='navbar-logo'>
              ProfixExpress
            </Link>
          </div>
        </div>
      </div>
      <div className='bookingpagecnt'>
        <div className='signin_cnt'>
          <h2 className='signin_title'>Professional Information</h2>
          <p className='signin_para'>
            Fill in your expertise, experience, and service preferences.
          </p>

          <div className='inputcnt'>
            <label>What Category does your task fall under?</label>
            <div className='category-buttons'>
              {Object.keys(categories).map((categoryName) => (
                <button
                  key={categoryName}
                  onClick={() => handleCategoryChange(categoryName)}
                  className={`category-btn ${
                    selectedCategory === categoryName ? "active" : ""
                  }`}
                >
                  {categoryName}
                </button>
              ))}
            </div>
          </div>

          <div className='divider'></div>

          <div className='thegap'></div>

          {/* Service Selection */}
          {selectedCategory && categories[selectedCategory]?.services && (
            <div>
              <label className='thealtinput'>What is the service type?</label>
              <div className='thespace'></div>
              <div className='service-options'>
                {Object.values(categories[selectedCategory].services).map(
                  (service) => (
                    <div key={service.name} className='service-item'>
                      <input
                        type='checkbox'
                        id={service.name}
                        checked={selectedServices.some(
                          (s) => s.name === service.name
                        )}
                        onChange={() => handleServiceToggle(service.name)}
                      />
                      <label className='category-btn' htmlFor={service.name}>
                        {service.name}
                      </label>
                    </div>
                  )
                )}
              </div>
            </div>
          )}
          <div className='thegap'></div>
          {/* Display Selected Services */}
          <div className='selected-services'>
            {selectedServices.length > 0 ? (
              <div className='selected-services-list'>
                {selectedServices.map((service, index) => (
                  <div key={index} className='selected-service'>
                    <span>{service.name}</span>
                    <button onClick={() => handleServiceToggle(service.name)}>
                      Remove
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <p></p>
            )}
          </div>

          <div className='thebiggap'></div>

          <div className='inputcnt'>
            <label>Years of experience</label>
            <input
              type='number'
              value={expyears}
              onChange={(e) => setExpyears(e.target.value)}
            />
          </div>
          <p className='formtitle'>Certification</p>
          <div className='theflexs'>
            <div className='inputcnt'>
              <input
                type='text'
                value={certificateName}
                placeholder='Enter certificate name'
                onChange={(e) => setCertificateName(e.target.value)}
              />
            </div>
            <div className='inputcnt'>
              <input
                type='text'
                value={issuingOrganisation}
                placeholder='Enter Issuing organisation'
                onChange={(e) => setIssuingOrganisation(e.target.value)}
              />
            </div>
          </div>

          <div className='theflexs'>
            <div className='inputcnt'>
              <label htmlFor=''>Issuing date</label>
              <input
                type='month'
                value={monthyear}
                placeholder='month and year'
                onChange={(e) => setMonthyear(e.target.value)}
              />
            </div>
            <div className='inputcnt'>
              <label htmlFor=''>Upload certificate</label>
              <input
                type='file'
                accept='.jpg, .png, .pdf'
                onChange={(e) => handleFileChange(e, setCertificateFile)}
              />
            </div>
          </div>

          <p className='formtitle'>Working Hours</p>

          <div className='inputcnt'>
            <label htmlFor=''>
              What time of the day do you want it to be done?
            </label>
            <div className='thechoose'>
              <div
                onClick={() => setSelecttday("morning")}
                className={
                  selecttday === "morning" ? "selectactive" : "selectnotactive"
                }
              >
                <p className='seact'>Morning</p>
                <p className='seactn'>Before 10am</p>
              </div>
              <div
                onClick={() => setSelecttday("midday")}
                className={
                  selecttday === "midday" ? "selectactive" : "selectnotactive"
                }
              >
                <p className='seact'>Midday</p>
                <p className='seactn'>10am - 2pm</p>
              </div>
              <div
                onClick={() => setSelecttday("afternoon")}
                className={
                  selecttday === "afternoon"
                    ? "selectactive"
                    : "selectnotactive"
                }
              >
                <p className='seact'>Afternoon</p>
                <p className='seactn'>2pm - 6pm</p>
              </div>
              <div
                onClick={() => setSelecttday("evening")}
                className={
                  selecttday === "evening" ? "selectactive" : "selectnotactive"
                }
              >
                <p className='seact'>Evening</p>
                <p className='seactn'>After 6pm</p>
              </div>
            </div>
          </div>

          <div className='thebiggap'></div>
          <div className='theflexs'>
            <div className='inputcnt'>
              <label>Government Issued ID</label>
              <select
                value={govissuedid}
                onChange={(e) => setGovIssuedId(e.target.value)}
              >
                <option value=''>Select ID</option>
                <option value='NIN'>NIN</option>
                <option value='Passport'>Passport</option>
              </select>
            </div>
            <div className='inputcnt'>
              <label>Upload ID</label>
              <input
                type='file'
                accept='.jpg, .png, .pdf'
                onChange={(e) => handleFileChange(e, setGovIssuedIdFile)}
              />
            </div>
          </div>

          <p className='formtitle'>Proof of Address</p>
          <div className='inputcnt'>
            <input
              type='file'
              accept='.jpg, .png, .pdf'
              onChange={(e) => handleFileChange(e, setProofAddressFile)}
            />
          </div>

          <p className='formtitle'>Upload your profile picture</p>
          <div className='inputcnt'>
            <input
              type='file'
              accept='.jpg, .png'
              onChange={(e) => handleFileChange(e, setProfileFile)}
            />
          </div>

          <button
            className='thesigninbtn'
            onClick={saveDetails}
            disabled={loading}
          >
            {loading ? "Saving..." : "Continue"}
          </button>
        </div>
      </div>
    </>
  );
}

export default InfopageTwo;
